
    import '/home/ec2-user/Youlify-Design/docs/blog/form-names.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-blog-form-names-demo-en-us-0"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/home/ec2-user/Youlify-Design/docs/blog/form-names.en-US.md?type=demo')
};